import React from 'react';
import ReactDOM from 'react-dom';
import Main from './Main';
import * as serviceWorker from './serviceWorker';
import { msalInstance } from './hooks/msalConfig';
// import 'jquery/dist/jquery.min';
// import 'bootstrap/dist/css/bootstrap.css';

const render = () => ReactDOM.render(<Main />, document.getElementById('root'));

// Procesa el retorno del login por redirect (flujo usado en móviles, donde los
// popups suelen bloquearse) ANTES de montar la app: MSAL completa el token y,
// con navigateToLoginRequestUrl, vuelve a la página que inició el login.
// En cargas normales (sin redirect) resuelve de inmediato y monta igual.
msalInstance
    .handleRedirectPromise()
    .then(render)
    .catch((e) => {
        console.error('MSAL redirect error', e);
        render();
    });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();